// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/.pnpm/css-loader@4.3.0_webpack@4.46.0/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".icon-correct[data-v-7d17e201]{color:green}.icon-cancel[data-v-7d17e201]{color:red}.text[data-v-7d17e201]{font-size:.8125rem;line-height:1}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
